'use client'

import { ModelsNews } from '@/api/generated-api'
import { Link } from '@/i18n/routing'
import Image from '@/ui/MediaImage'

import { formatNewsRelativeTime, getNewsDisplayDate } from '../../utils/date'
import { getPrimaryNewsTagLabel } from '../../utils/newsTags'
import NewsCategoryBadge from './NewsCategoryBadge'
import S from './NewsHeroFeatured.module.scss'

type NewsHeroSideArticleProps = {
  news: ModelsNews
  locale: string
}

const NewsHeroSideArticle = ({ news, locale }: NewsHeroSideArticleProps) => {
  const tagLabel = getPrimaryNewsTagLabel(news)
  const timeLabel = formatNewsRelativeTime(getNewsDisplayDate(news), locale)

  return (
    <Link href={`/news/${news.id}`} className={S.sideArticle}>
      <div className={S.sideImage}>
        {news.header_image_url && (
          <Image
            src={news.header_image_url}
            alt={news.title || 'News image'}
            fill
            className={S.sideImageContent}
            sizes="(max-width: 768px) 160px, (max-width: 992px) 150px, 220px"
          />
        )}
      </div>
      <div className={S.sideContent}>
        <div className={S.metaRow}>
          {tagLabel && <NewsCategoryBadge label={tagLabel} />}
          {timeLabel && <span className={S.time}>{timeLabel}</span>}
        </div>
        <h3 className={S.sideTitle}>{news.title}</h3>
      </div>
    </Link>
  )
}

export default NewsHeroSideArticle
